import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/meetix-logo.png'
import _imports_1 from '@/assets/img/login-meetix.jpg'


const _withScopeId = n => (_pushScopeId("data-v-09dfdf6c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "logo-container" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "meetix-img",
    class: "meetix-logo"
  })
], -1))
const _hoisted_2 = {
  key: 0,
  class: "errors-container"
}
const _hoisted_3 = {
  key: 0,
  class: "invalid-cred-container"
}
const _hoisted_4 = { class: "errors-input-container" }
const _hoisted_5 = { class: "form-container" }
const _hoisted_6 = { class: "label-form" }
const _hoisted_7 = { class: "label-form" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "Meetys Image",
  class: "meetix-side-img"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loader = _resolveComponent("Loader")!
  const _component_InfoCircleOutlined = _resolveComponent("InfoCircleOutlined")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_input_password = _resolveComponent("a-input-password")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createVNode(_component_Loader, {
        "is-loaded": !_ctx.loading
      }, null, 8, ["is-loaded"])
    ]),
    _createVNode(_component_a_row, { class: "login-container" }, {
      default: _withCtx(() => [
        _createVNode(_component_a_col, {
          xs: { span: 24, offset: 0},
          sm: { span: 24, offset: 0},
          md: {span: 11, offset: 0},
          lg: { span: 11, offset: 0 },
          xl: { span: 11, offset: 0 },
          xxl: { span: 11, offset: 0 },
          class: "side-container"
        }, {
          default: _withCtx(() => [
            _hoisted_1,
            (_ctx.form.errors.length !== 0 || _ctx.form.errorMessage )
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  (_ctx.form.errorMessage!=='')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        _createVNode(_component_InfoCircleOutlined, { class: "error-icon" }),
                        _createElementVNode("span", null, _toDisplayString(_ctx.t(`Meet.${_ctx.form.errorMessage}`)), 1)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_4, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.errors.slice(0, 1), (error) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: error,
                        class: "error-form"
                      }, [
                        _createVNode(_component_InfoCircleOutlined, { class: "error-icon" }),
                        _createElementVNode("span", null, _toDisplayString(_ctx.t(`Meet.${error.name[0]}`)) + " " + _toDisplayString(_ctx.t(`Meet.${error.errors[0]}`)), 1)
                      ]))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_a_form, {
                ref: "formRef",
                layout: "vertical",
                rules: _ctx.rules,
                model: _ctx.form
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_col, { span: 24 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_form_item, {
                            name: "email",
                            "validate-status": '',
                            help: ''
                          }, {
                            label: _withCtx(() => [
                              _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.t('Meet.Email')), 1)
                            ]),
                            default: _withCtx(() => [
                              _createVNode(_component_a_input, {
                                value: _ctx.form.email,
                                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.email) = $event)),
                                placeholder: _ctx.t('Meet.Email'),
                                class: "login-input"
                              }, null, 8, ["value", "placeholder"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_row, { gutter: 16 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_col, { span: 24 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_form_item, {
                            name: "password",
                            "validate-status": '',
                            help: ''
                          }, {
                            label: _withCtx(() => [
                              _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.t('Meet.Password')), 1)
                            ]),
                            default: _withCtx(() => [
                              _createVNode(_component_a_input_password, {
                                value: _ctx.form.password,
                                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.password) = $event)),
                                visible: _ctx.visible,
                                "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.visible) = $event)),
                                placeholder: _ctx.t('Meet.Password'),
                                class: "login-input"
                              }, null, 8, ["value", "visible", "placeholder"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_row, { class: "login-btn-container" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_col, {
                        xs: { span: 24},
                        sm: { span: 24},
                        md: {span: 24},
                        lg: { span: 24 },
                        xl: { span: 24 },
                        xxl: { span: 24 }
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("button", {
                            class: "login-btn",
                            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)))
                          }, _toDisplayString(_ctx.t('Meet.SignIn')), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["rules", "model"])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_a_col, {
          xs: { span: 0, offset: 0 },
          sm: { span: 0, offset: 0 },
          md: {span: 13, offset: 0},
          lg: { span: 13, offset: 0 },
          xl: { span: 13, offset: 0 },
          xxl: { span: 13 },
          class: "login-img"
        }, {
          default: _withCtx(() => [
            _hoisted_8
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}